export default __webpack_public_path__ + "static/media/growdeoro-logo.635654bf.PNG";